interface UserSignedInProps {
  readonly username: string
  readonly email: string
  readonly firstName: string
  readonly lastName: string
}

interface UserProps {
  readonly username: string
  readonly email: string
  readonly firstName: string
  readonly lastName: string
  readonly isSignedIn: boolean
}

export class User {
  public readonly username: string
  public readonly email: string
  public readonly firstName: string
  public readonly lastName: string
  public readonly isSignedIn: boolean

  public get isUsernameSet() {
    return this.username !== ''
  }

  private constructor(userProps: UserProps) {
    this.username = userProps.username
    this.email = userProps.email
    this.firstName = userProps.firstName
    this.lastName = userProps.lastName
    this.isSignedIn = userProps.isSignedIn
  }

  static asSignedIn(userProps: UserSignedInProps): User {
    return new User({
      ...userProps,
      isSignedIn: true,
    })
  }

  static asNotSignedIn(): User {
    return new User({
      username: '',
      email: '',
      firstName: '',
      lastName: '',
      isSignedIn: false,
    })
  }
}
